import { AimsCommonPopupEditorComponent, AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { InvAttachedItem, InvManuallyExpended } from 'src/models';
import { InventoryReturnPopupComponent } from '../../assetMgmt/workorders/workOrder/inventory-return-popup/inventory-return-popup.component';

@Component({
  selector: 'app-manually-expended',
  templateUrl: './manually-expended.component.html',
  styleUrls: ['./manually-expended.component.css']
})
export class ManuallyExpendedComponent implements OnInit {

  constructor(private transferHttp: TransferHttpService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,) {

  }

  manuallyExpendedId: number = 0;
  manuallyExpended: InvManuallyExpended;
  manuallyAttachedItems: Array<InvAttachedItem>;

  public employeeValues = this.transferHttp.getCache('employeeDropdown');

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

 partsTableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'return', label: 'Return', type: 'button',
            events: { click: (element) => this.openReturnPopup(element) }, filter: false },
    { key: 'inventoryItem.barcode', label: 'Barcode', type: 'number', editable: false },
    { key: 'inventoryItem.description', label: 'Description', type: 'string', width: 300, editable: false },
    { key: 'quantity', label: 'Quantity', type: 'dynamic', width: 100 },
    { key: 'inventoryItem.unitOfIssueId', label: 'Unit of Issue', type: 'string', width: 60, editable: false  },
    { key: 'partCost', label: 'Part Cost', type: 'dynamic', filter: false, editable: false },
  ];

  partsSubTableHeader: AimsCommonTableHeader[] = [
    { key: 'quantity', label: 'Quantity', type: 'number', filter: false },
    { key: 'pulledByEmployeeId', label: 'User', type: 'dynamic', filter: false },
    { key: 'unitCost', label: 'Unit Cost', type: 'dynamic', filter: false },
  ];

  partsTablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false,
    filter: false
  };

  loadAttachedItems() {
    this.transferHttp.get(`inventory/GetManuallyExpendedItems?manuallyExpendedId=${this.manuallyExpended.manuallyExpendedId}`).subscribe({
      next: manuallyAttachedItems => {
        this.manuallyAttachedItems = manuallyAttachedItems;
        this.showSpinner = false;
      },
      error: _ => {
        this.showSpinner = false;
      }
    });
  }

  loadManuallyExpended(manuallyExpendedId: number) {
    this.showSpinner = true;

    this.transferHttp.getSingle(`inventory/GetManuallyExpended?manuallyExpendedId=${this.manuallyExpendedId}` ).subscribe({
      next: manuallyExpended => {
        if (manuallyExpended) {
          this.manuallyExpended = manuallyExpended;
          this.loadAttachedItems();
        }
        else {
          alert("no item exists with that number");
        }
        this.showSpinner = false;
      },
      error: _ => {
        this.showSpinner = false;
      }
    });
  }

  public openReturnPopup(itemToReturn: InvAttachedItem) {
    const originalQuantity = this.getManualItemPulledQuantity(itemToReturn.attachedItemId);

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
            data: {
                btnOkText: 'Return',
                header: 'Return Quantity',
                content: InventoryReturnPopupComponent,
                contentData: { itemToReturn: itemToReturn, maxReturnableQuantity: originalQuantity },
            },
            disableClose: true
        });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.returnInventoryItemQuantity(itemToReturn.attachedItemId, dialogResult.returnedQuantity);
      }
    });
  }

  public returnInventoryItemQuantity(attachedItemId: number, returnedQuantity: number) {
    this.spinnerText = "Returning Inventory Item...";
    this.showSpinner = true;

    var url = `inventory/RemoveQuantityFromAttachedItem?attachedItemId=${attachedItemId}&quantityToRemove=${returnedQuantity}`;
    this.transferHttp.put(url, null)
      .subscribe({
        next: _ => {
          this.loadAttachedItems();
          this.showSpinner = false;
        },
        error: err => {
          this.showSpinner = false;
        }
      });
  }

  public getManualItemPulledQuantity(attachedItemId: number): number {
    const sum: number = this.manuallyAttachedItems.filter(wi => wi.attachedItemId === attachedItemId)[0]
      .invAttachedItemPulled
      .map(i => i.quantity)
      .reduce((sum, current) => sum + current, 0);
    return sum;
  }

  public getManualItemPulledCost(attachedItemId: number): number {
    const totalCost: number = this.manuallyAttachedItems.filter(wi => wi.attachedItemId === attachedItemId)[0]
      .invAttachedItemPulled
      .map(i => i.quantity *  i.inventoryItemReceived.costPerUnit)
      .reduce((sum, current) => sum + current, 0);
    return totalCost;
  }

  public getTotalItemPulledCost(): number {
    var totalCost: number = 0;
    this.manuallyAttachedItems.forEach(iwi => {
      totalCost += iwi.invAttachedItemPulled
            .map(i => i.quantity *  i.inventoryItemReceived.costPerUnit)
            .reduce((sum, current) => sum + current, 0);
    })
    return totalCost;
  }

  ngOnInit(): void {
   this.route.params.subscribe(p => {
      if (p['id']) {
        this.manuallyExpendedId = p['id'];
        this.loadManuallyExpended(this.manuallyExpendedId);
      }
   });
  }

}
